<template>
  <o-form-wrapper
    v-model="item"
    :server-errors="_se"
    :v="$v.item"
    :schema="schema"
    :form-state="formState"
  >
    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="description"
    >
      <o-textarea
        :form-state="formState"
        max-rows="5"
        :server-errors="_se"
        :validators="$v.item"
        name="description"
        v-bind="schema.fields.description"
        v-model="item.description"
      ></o-textarea>
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="statuses"
    >
      <notification-status-form-table
        :form-state="formState"
        :label="schema.fields.statuses.label"
        :level="level + 1"
        :server-errors="_se.statuses"
        :validators="$v.item.statuses"
        v-model="item.statuses"
        :buttons="item.buttons"
      >
      </notification-status-form-table>
      <!-- UNCOMMENT TO USE Cards
        <notification-status-form-cards v-model="item.statuses"
            :validators="$v.item.statuses"
            :form-state="formState"
            :label="schema.fields.statuses.label"
            :level="level+1"
            :server-errors="_se.statuses">
        </notification-status-form-cards>
        -->
    </o-widget-wrapper>

    <o-widget-wrapper
      :form-state="formState"
      :schema="schema"
      :server-errors="_se"
      :validators="$v.item"
      name="buttons"
    >
      <notification-button-form-table
        :form-state="formState"
        :label="schema.fields.buttons.label"
        :level="level + 1"
        :server-errors="_se.buttons"
        :validators="$v.item.buttons"
        v-model="item.buttons"
      >
      </notification-button-form-table>
      <!-- UNCOMMENT TO USE Cards
        <notification-button-form-cards v-model="item.buttons"
            :validators="$v.item.buttons"
            :form-state="formState"
            :label="schema.fields.buttons.label"
            :level="level+1"
            :server-errors="_se.buttons">
        </notification-button-form-cards>
        -->
    </o-widget-wrapper>
  </o-form-wrapper>
</template>

<script>
import schema from "../../schema/index.js";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify.js";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
} from "../../../vue-ocom/mixins";
import { validationMixin } from "vuelidate";
import OWidgetWrapper from "../../../vue-ocom/components/forms/OWidgetWrapper.vue";
import OTextField from "../../../vue-ocom/components/forms/fields/OTextField.vue";
import OSelect from "../../../vue-ocom/components/forms/fields/OSelect.vue";
import OCheckbox from "../../../vue-ocom/components/forms/fields/OCheckbox.vue";
import OFormWrapper from "../../../vue-ocom/components/forms/OFormWrapper.vue";
import ODateTime from "../../../vue-ocom/components/forms/fields/ODateTime.vue";

import { default as NotificationStatusFormTable } from "../../notification_status/components/ItemFormTable.vue";
// import { default as NotificationStatusFormCards } from "../../notification_status/components/ItemFormCards.vue";
import { default as NotificationButtonFormTable } from "../../notification_button/components/ItemFormTable.vue";
// import { default as NotificationButtonFormCards } from "../../notification_button/components/ItemFormCards.vue";

export default {
  mixins: [
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("Notification"),
    CreateCodeTableFetchMixin([]),
  ],
  components: {
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,

    OCheckbox,
    OSelect,
    OTextField,

    NotificationStatusFormTable,
    //NotificationStatusFormCards,
    NotificationButtonFormTable,
    //NotificationButtonFormCards,
  },
  props: {
    item: { type: Object, default: () => {} },
    level: { type: Number, default: 0 },
    inModal: { type: Boolean, default: false },
  },
  data: () => ({
    schemaModel: cleanUpModel(schema.Notification, {}),
  }),
  methods: {},
  computed: {
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
  },
  watch: {},
  created() {},
};
</script>
